import theme from "@/constants/theme";

const styles: Record<string, React.CSSProperties> = {
  container: {
    minHeight: "100vh",
    backgroundColor: theme.colors.background.primary,
    display: "flex",
    flexDirection: "column",
  },
  scrollContainer: {
    flexGrow: 1,
    paddingBottom: 32,
  },
  img: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  linearGradient: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background:
      "linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%)",
  },
  content: {
    padding: "24px 16px",
    flex: 1,
  },
  title: {
    marginBottom: 16,
    color: theme.colors.text.title,
  },
  description: {
    color: theme.colors.text.body,
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "space-between",
    padding: "16px",
    gap: 8,
  },
  backButton: {
    flex: 1,
    padding: "12px 16px",
    backgroundColor: "transparent",
    border: `1px solid ${theme.colors.primary}`,
    color: theme.colors.primary,
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: "bold",
  },
  nextButton: {
    flex: 1,
    padding: "12px 16px",
    backgroundColor: theme.colors.primary,
    color: theme.colors.text.default,
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: "bold",
    border: "none",
  },
  backButtonText: {
    textAlign: "center",
  },
  nextButtonText: {
    textAlign: "center",
  },
};

export default styles;
